import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./Slice/Login/Login";
import RegiterReducer from "./Slice/Login/Register";
import OrgReducer from "./Slice/Admin/Org";
import BrancheReducer from "./Slice/Admin/Branch";
import SpecialityReducer from "./Slice/Admin/Speciality";
import RoleReducer from "./Slice/Admin/Roles";
import DoctorReducer from "./Slice/Admin/Doctor";
import PatientReducer from "./Slice/Doctor/Patients";
import AppointmentReducer from "./Slice/Doctor/Appointments";
import SlotReducer from "./Slice/Doctor/Slots";
import DoctorDetailReducer from "./Slice/Patient/Doctors";
import BookingReducer from "./Slice/Patient/Booking";
import AppointmentsReducer from "./Slice/Patient/Appointments";
import CallReducer from "./Slice/Doctor/callSlice";
import MedicineReducer from "./Slice/Patient/Medicine";
import UploadDocReducer from "./Slice/Patient/uploadDoc";
import InvestigationReducer from "./Slice/Admin/Investigation";
import logoutReducer from "./Slice/Login/Logout";
import VitalReducer from "./Slice/Doctor/Vitals";
import LabReducer from "./Slice/Doctor/lab";

const store = configureStore({
  reducer: {
    login: loginReducer,
    logout: logoutReducer,
    register: RegiterReducer,
    org: OrgReducer,
    branch: BrancheReducer,
    speciality: SpecialityReducer,
    role: RoleReducer,
    doctor: DoctorReducer,
    patient: PatientReducer,
    appointment: AppointmentReducer,
    slot: SlotReducer,
    doctorDetail: DoctorDetailReducer,
    booking: BookingReducer,
    medicine: MedicineReducer,

    patientAppointment: AppointmentsReducer,
    call: CallReducer,

    upload: UploadDocReducer,

    investigation: InvestigationReducer,

    vital: VitalReducer,
    lab: LabReducer,
  },
});

export default store;
